import React, {
  PropsWithChildren,
  ReactNode,
  RefObject,
  useCallback,
  useContext,
  useRef,
  useState
} from 'react'

type AppRootContextValue = {
  ref: RefObject<HTMLDivElement>
  mountDialog: (node: ReactNode) => void
  unmountDialog: () => void
}

const AppRootContext = React.createContext<AppRootContextValue>({} as AppRootContextValue)

export const AppRoot = ({ children }: PropsWithChildren<any>) => {
  const [dialog, setDialog] = useState<ReactNode>()

  const ref = useRef<HTMLDivElement>(null)
  const mount = useCallback((node) => {
    setDialog(node)
  }, [])
  const unmount = useCallback(() => {
    setDialog(null)
  }, [])

  return (
    <AppRootContext.Provider value={{ ref, mountDialog: mount, unmountDialog: unmount }}>
      <div ref={ref}>{children}</div>
      {dialog}
    </AppRootContext.Provider>
  )
}

export const useAppRoot = () => {
  return useContext(AppRootContext)
}
